module.exports = __webpack_public_path__ + "img/round-arrow.d5a554fc.svg";